import React from 'react'
import Content, { meta } from '@/content/seo/sv/kompletta-hjul/pickup/ram-rampage.mdx'
import { SeoPage } from '@/lib/seo/seoPage'
import { makeSeoStaticProps } from '@/lib/seo/seoStaticProps'

export const getStaticProps = makeSeoStaticProps()

const Page = () => (
  <SeoPage meta={meta}>
    <Content />
  </SeoPage>
)

export default Page
